import { ComponentChildren } from 'preact'
import FormContext from './FormContext'
import type { UseForm } from './useForm'

export interface FormProviderProps extends UseForm {
  children: ComponentChildren
}

function FormProvider({ children, ...contextValue }: FormProviderProps) {
  return <FormContext.Provider value={contextValue}>{children}</FormContext.Provider>
}

export default FormProvider
